import React from "react";

import MuiCardHeader from "@material-ui/core/CardHeader";

const CardHeader = ({ style, ...props }) => (
  <MuiCardHeader
    style={{ marginLeft: 12, fontSize: 14, color: "#3F51B5", ...style }}
    disableTypography={true}
    {...props}
  />
);

export default CardHeader;
